import _ from 'lodash';
var localesReplacement = function (replacements, origin) {
    var r = _.get(replacements, origin);
    return r ? r : origin;
};
export default localesReplacement;
